function iaInitKeepsakeCharms() {
  var root = document.querySelector('[data-ia-kc]');
  if (!root || root.dataset.iaInited) return;
  root.dataset.iaInited = '1';

  function esc(s) { return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;'); }
  function money(cents) { return window.IrisCart ? window.IrisCart.money(cents) : '€' + (cents / 100).toFixed(2).replace('.', ','); }

  // Real products rendered by Liquid from the Keepsake Charms collection; labels come from the locale files.
  var products = [], L = {};
  try { products = JSON.parse(root.querySelector('[data-ia-kc-products]').textContent) || []; } catch (e) { products = []; }
  try { L = JSON.parse(root.querySelector('[data-ia-kc-labels]').textContent) || {}; } catch (e) { L = {}; }
  // the t filter HTML-escapes its output (& → &amp;), so decode the labels before they are escaped again
  var dec = document.createElement('textarea');
  Object.keys(L).forEach(function (k) { dec.innerHTML = L[k]; L[k] = dec.value; });
  products.forEach(function (p, i) {
    p.order = i;
    p.min = Math.min.apply(null, p.variants.map(function (v) { return v.price; }));
    p.max = Math.max.apply(null, p.variants.map(function (v) { return v.price; }));
  });

  var FAMS = ['hearts', 'flowers', 'celestial', 'symbols', 'vintage'];
  var present = {};
  products.forEach(function (p) { present[p.fam] = true; });
  var filterData = [{ k: 'all', label: L.all || 'All Charms' }].concat(FAMS.filter(function (k) { return present[k]; }).map(function (k) { return { k: k, label: L[k] || k }; }));
  var sorts = [{ k: 'featured', label: L.sort_featured || 'Featured' }, { k: 'low', label: L.sort_low || 'Price: low to high' }, { k: 'high', label: L.sort_high || 'Price: high to low' }, { k: 'az', label: L.sort_az || 'Name: A–Z' }];

  var state = { filter: 'all', sort: 'featured' };
  var filtersEl = root.querySelector('[data-ia-kc-filters]'), sortEl = root.querySelector('[data-ia-kc-sort]'), gridEl = root.querySelector('[data-ia-kc-grid]');

  sortEl.innerHTML = sorts.map(function (s) { return '<option value="' + s.k + '">' + esc(s.label) + '</option>'; }).join('');
  sortEl.addEventListener('change', function () { state.sort = sortEl.value; renderGrid(); });

  function renderFilters() {
    filtersEl.innerHTML = filterData.map(function (f) {
      return '<button type="button" class="ia-kc-chip' + (state.filter === f.k ? ' is-on' : '') + '" data-k="' + f.k + '" aria-pressed="' + (state.filter === f.k) + '">' + esc(f.label) + '</button>';
    }).join('');
  }
  filtersEl.addEventListener('click', function (e) {
    var b = e.target.closest('[data-k]'); if (!b) return;
    state.filter = b.dataset.k; renderFilters(); renderGrid();
  });

  function title(t) { return t.replace(/^["“«]|["”»]$/g, ''); }

  function renderGrid() {
    var list = products.filter(function (p) { return state.filter === 'all' || state.filter === p.fam; });
    list.sort(function (a, b) {
      if (state.sort === 'low') return a.min - b.min || a.order - b.order;
      if (state.sort === 'high') return b.max - a.max || a.order - b.order;
      if (state.sort === 'az') return title(a.title).localeCompare(title(b.title));
      return FAMS.indexOf(a.fam) - FAMS.indexOf(b.fam) || a.order - b.order;
    });
    gridEl.innerHTML = '';
    if (!list.length) {
      gridEl.innerHTML = '<p style="grid-column:1/-1;text-align:center;font-style:italic;color:#8a7a64;">' + esc(L.empty || 'New charms are on their way to the atelier.') + '</p>';
      return;
    }
    list.forEach(function (p) {
      var many = p.variants.length > 1, v = p.variants[0];
      var price = p.min !== p.max ? (L.from || 'From') + ' ' + money(p.min) : money(p.min);
      var card = document.createElement('div');
      card.className = 'ia-kc-card';
      card.innerHTML =
        '<a href="' + esc(p.url) + '" class="ia-kc-img"' + (p.img ? ' style="background-image:url(\'' + esc(p.img) + '\')"' : '') + ' aria-label="' + esc(p.title) + '"></a>' +
        '<a href="' + esc(p.url) + '" class="ia-kc-name">' + esc(p.title) + '</a>' +
        '<span class="ia-kc-price">' + price + (many ? ' <span class="ia-kc-n">· ' + p.variants.length + ' ' + esc(L.designs || 'designs') + '</span>' : '') + '</span>' +
        (many
          ? '<a href="' + esc(p.url) + '" class="ia-kc-add">' + esc(L.choose || 'Choose design') + ' &rarr;</a>'
          : '<button type="button" class="ia-kc-add" data-ia-kc-add>' + esc(v.available === false ? (L.sold_out || 'Sold out') : (L.add || 'Add to cart')) + '</button>');
      var addBtn = card.querySelector('[data-ia-kc-add]');
      if (addBtn) {
        addBtn.disabled = v.available === false;
        if (window.IrisCart) window.IrisCart.bind(addBtn, function () { return [{ id: v.id, quantity: 1 }]; }, { addedLabel: '✓ ' + (L.added || 'Added'), idleLabel: L.add || 'Add to cart' });
      }
      gridEl.appendChild(card);
    });
  }

  renderFilters();
  renderGrid();
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iaInitKeepsakeCharms); else iaInitKeepsakeCharms();
document.addEventListener('shopify:section:load', iaInitKeepsakeCharms);
